import { Link, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { QuoteCTA } from "../components/CTA";
import { getProject } from "../data/site";

export default function ProjectDetail() {
  const { slug } = useParams();
  const project = getProject(slug);
  if (!project) {
    return (
      <div className="container notfound">
        <h1>Project not found</h1>
        <p>The project you're looking for doesn't exist or has moved.</p>
        <Link to="/projects" className="btn btn-orange">View All Projects <ArrowRight size={15} /></Link>
      </div>
    );
  }
  return (
    <>
      <SEO title={`${project.title} | CustoRacks Projects`} description={`${project.title} — ${project.description}`} />
      <section className="section" style={{ paddingTop: 72 }}>
        <div className="container">
          <div className="crumbs" style={{ color: "var(--muted)" }}>
            <Link to="/" style={{ color: "var(--blue)" }}>Home</Link> / <Link to="/projects" style={{ color: "var(--blue)" }}>Projects</Link> / {project.title}
          </div>
          <div className="pd-top" data-testid="project-detail">
            <div className="pd-img"><img src={project.image} alt={project.title} /></div>
            <div className="pd-intro">
              <span className="card-cat">{project.system}</span>
              <h1>{project.title}</h1>
              <div className="project-meta"><span>{project.location}</span><span>{project.industry}</span></div>
              <p>{project.description}</p>
              <p style={{ color: "var(--muted)", fontSize: 13.5, marginTop: 16 }}>
                This is a representative project profile. Detailed specifications, photographs and outcomes are published as each project is documented.
              </p>
              <div className="pd-actions">
                <Link to="/contact" className="btn btn-orange" data-testid="project-quote-btn">Discuss a Similar Project <ArrowRight size={15} /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
